import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { List, ListItem, Typography, Button, TextField } from '@mui/material'
import { AddBox as CreateIcon } from '@mui/icons-material'

import { createPageAsync } from './pagesSlice'
import { selectPagesPaneIsVisible } from '../ui/uiSlice'

const classes = {
  root: {},
  listItem: {
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
    background: 'white',
    margin: 0,
    marginTop: 1,
  },
  button: { margin: 1 },
}

export default function AddPage(props) {
  const dispatch = useDispatch()
  const [title, setTitle] = useState('')

  // The form lives in the pages drawer, so it "opens" when the drawer does:
  // put the cursor in the title then, ready to type. `preventScroll`, since
  // the drawer is still sliding in and the browser would otherwise scroll to
  // where the field is at that moment.
  const isOpen = useSelector(selectPagesPaneIsVisible)
  const titleRef = useRef(null)
  useEffect(() => {
    if (isOpen) {
      titleRef.current?.focus({ preventScroll: true })
    }
  }, [isOpen])

  const pageData = () => {
    return {
      title,
    }
  }

  const handleChange = (e) => {
    // console.log('<AddPage />.handleChange()')
    setTitle(e.target.value)
  }

  const handleKeyPress = (e) => {
    if (e.charCode === 13) {
      e.preventDefault()
      e.stopPropagation()
      handleClick(e)
    }
  }

  const handleClick = (e) => {
    // console.log('<AddPage />.handleClick()')
    dispatch(createPageAsync(pageData()))
    setTitle('')
  }

  return (
    <List>
      <ListItem sx={classes.listItem}>
        <Typography variant='h6'>New page</Typography>
        <form>
          <TextField
            sx={classes.textField}
            label='Title'
            inputRef={titleRef}
            value={title}
            variant='outlined'
            size='small'
            onKeyPress={handleKeyPress}
            onChange={handleChange}
          />
          <Button
            sx={classes.button}
            color='primary'
            variant='contained'
            aria-label='create page'
            onClick={handleClick}
            endIcon={<CreateIcon />}
          >
            Create
          </Button>
        </form>
      </ListItem>
    </List>
  )
}
